import { Partial } from '@40seas/entities/common';
import { CreateInviteDto } from './create.invite.dto';

export class UpdateInviteDto extends Partial(CreateInviteDto) {}
